//import product data from server here
const data = [
    { 
      product_id: Date.now(),
      product_name: 'Apple',
      seller_price: '10', 
      qty: '500', 
      description: 'A delicious and healthy snack',
      seller_name: 'Daniel', 
      category: 'Produce',
      location: 'Cairo',
    },
    { 
      product_id: Date.now(),
      product_name: 'Orange',
      seller_price: '10', 
      qty: '500', 
      description: 'A delicious and healthy snack',
      seller_name: 'Daniel', 
      category: 'Produce',
      location: 'Cairo',
    },
    { 
      product_id: Date.now(),
      product_name: 'Tomato',
      seller_price: '10', 
      qty: '500', 
      description: 'A delicious and healthy snack',
      seller_name: 'Daniel', 
      category: 'Produce',
      location: 'Cairo',
    },
  ]

export default data;